<div class="center-container">
 
    <button mat-raised-button color="primary"> <span>
        <div class="flex flex-row justify-center items-center">
            <mat-spinner diameter="20" color="#fff"></mat-spinner>
        </div>
    </span> {{wait_message}}</button>
</div>